import Image from "next/image";
import Link from "next/link";
import React from "react";

const InfoCard = ({
  iconSrc,
  iconWidth,
  iconHeight,
  title,
  description,
  bgClass,
  link,
}) => {
  return (
    <Link
      href={link}
      prefetch={false}
      className={`flex items-center w-full flex-nowrap flex-row justify-between relative overflow-hidden rounded-2xl ${bgClass}`}
    >
      <div className="flex flex-row items-center justify-center w-full gap-2 ml:justify-start sm:gap-10">
        <div className="w-1/2 flex items-center justify-center">
          <Image
            src={iconSrc}
            width={iconWidth}
            height={iconHeight}
            alt="icon"
            className="flex-shrink-0 object-cover"
          />
        </div>
        <div className="flex flex-wrap items-center w-full lg:flex-nowrap sm:justify-between">
          <div className="flex flex-col justify-start items-start text-left gap-1.5">
            <span className="text-xl font-bold leading-normal text-white">
              {title}
            </span>
            <span className="text-xs font-normal leading-normal text-white">
              {description}
            </span>
          </div>
          <span className="flex-shrink-0 text-sm leading-normal text-white underline text-opacity-70">
            Detaylı bilgi edin
          </span>
        </div>
      </div>
    </Link>
  );
};

export default InfoCard;
